module.exports = __webpack_public_path__ + "img/img_join_02.1751442b.jpg";